module.exports = __webpack_public_path__ + "static/media/refresh-moodboard-icon.951fa66b.svg";